import { securityOidcConfigurationsBySubdomainGetSlice } from './get';

export const { requestGetSecurityOidcConfigurationsBySubdomain, resetGetSecurityOidcConfigurationsBySubdomain } =
	securityOidcConfigurationsBySubdomainGetSlice.asyncActionCreators;
